import { render, staticRenderFns } from "./BaseProducts.vue?vue&type=template&id=5a5eef06&scoped=true&"
import script from "./BaseProducts.vue?vue&type=script&lang=js&"
export * from "./BaseProducts.vue?vue&type=script&lang=js&"
import style0 from "./BaseProducts.vue?vue&type=style&index=0&id=5a5eef06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5eef06",
  null
  
)

export default component.exports